



































import Vue from "vue";
import {
  ProductionOrderProcessWorkStationRecordServiceProxy,
} from "@/service-proxies/app-v2/coproduction.service-proxies";

import _ from "lodash";
import dayjs from "dayjs";
const popwsrsp = new ProductionOrderProcessWorkStationRecordServiceProxy();
const columns = [
  {
    title: "page_plan_order_no",
    dataIndex: "code",
  },
  {
    title: "page_plan_product_no",
    dataIndex: "productCode",
  },
  {
    title: "page_plan_product_name",
    dataIndex: "productName",
  },
  {
    title: "page_plan_craft_sort",
    dataIndex: "processSort",
  },
  {
    title: "page_process_code",
    dataIndex: "processCode",
  },
  {
    title: "page_plan_craft_name",
    dataIndex: "processName",
  },
  {
    title: "page_workstation_maintain_station_name",
    dataIndex: "workStationName",
  },
  {
    title: "page_station_capacity",
    dataIndex: "stationProductionCapacity",
    width: 200,
    scopedSlots: { customRender: "stationProductionCapacity" },
  },
  {// 超差预警
    title: "page_job_record_out_of_tolerance_warning",
    dataIndex: "overFlowWarning",
    width: 200,
    scopedSlots: { customRender: "overFlowWarning" },
  },
];

export default Vue.extend({
  data() {
    return {
      data: [],
      loading: true,
      confirmLoading: false
    };
  },
  props: {
    selectRows: {
      type: Object,
      default: () => ({}),
    },
    edit: {
      type: Boolean,
      default: false,
    },
    modal: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    columns() {
      return columns.map((item: any) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
  },
  watch: {
  },
  created() {
    console.log('selectRows',this.selectRows)
    this.getCodeRules();
  },
  methods: {
    async getCodeRules() {
      const res = await popwsrsp.getProcessWorkStationProductionCapacity(this.selectRows.id);
      console.log(res)
      this.data = res;
      this.loading = false
    },
    async handleOk() {
      console.log(this.data);
      this.confirmLoading = true;
      let arr = [];
      this.data.forEach((x) => {
        let obj = {
          poProcessWorkStationId: x.poProcessWorkStationId,
          stationProductionCapacity: x.stationProductionCapacity,
          overFlowWarning: x.overFlowWarning
        }
        arr.push(obj)
      })

      let res = await popwsrsp.batchUpdate(arr);
      this.confirmLoading = false;
      if(res) {
        this.$message.success('保存成功')
        this.handleCancel();
      }
      else {
        this.$message.error('保存失败')
      }
    },
    handleCancel() {
      this.$emit("close", false);
    },
  },
});
